import { CompanyService } from "../../core/http/service/CompanyService";
import { cleanMask } from "../../helpers/HelperFunctions";
import BaseResponse from "../../models/core/BaseResponse";
import Company from "../../models/core/company/Company";
import { CompanyHead } from "../../models/core/company/CompanyHead";
import UserAddress from "../../models/core/UserAddress";

export const RESET: string = 'RESET';
export const FETCH_COMPANIES: string = 'FETCH_COMPANIES';
export const FILTER_COMPANIES: string = 'FILTER_COMPANIES';
export const FETCH_COMPANIES_COMBO: string = 'FETCH_COMPANIES_COMBO';
export const SET_IDS_UNIDS = 'SET_IDS_UNIDS';
export const FETCH_UNIDS = 'FETCH_UNIDS';

const sendToAnalytics = (action: string = '', error: any = null) => {
    console.error(action, error);
}

export const fetchCompanyList = () => {
    const service: CompanyService = new CompanyService()

    return async (dispatch: any) => {
        try {
            const response: any = await service.getCompanies()
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            const companies: Company[] = []

            baseResponse?.data?.forEach((data: any) => {
                companies.push(new Company().fromJSON(data))
            })

            dispatch({
                type: FETCH_COMPANIES,
                companies: companies
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
};

export const filterCompanyList = (searchQuery: string) => {
    const service: CompanyService = new CompanyService()

    return async (dispatch: any) => {
        try {
            const response: any = await service.getCompanies()
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            const companies: Company[] = []

            baseResponse?.data?.forEach((data: any) => {
                companies.push(new Company().fromJSON(data))
            })

            const listaFiltrada = [...companies.filter(company => {
                const hasNomeFantasia = company.nomeFantasia.toUpperCase().indexOf(searchQuery.toUpperCase())

                if (hasNomeFantasia !== -1) return true;

                const hasCnpj = company.cnpj.toUpperCase().indexOf(cleanMask(searchQuery).toUpperCase())

                if (hasCnpj !== -1) return true;

                return false;
            })]


            dispatch({
                type: FILTER_COMPANIES,
                filteredCompanies: listaFiltrada
            })
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

const fillCompanyObject = (values: any) => {
    const address: UserAddress = new UserAddress().fromJSON({
        logradouro: values.logradouro.trim(),
        numero: values.numero.trim(),
        complemento: values.complemento.trim(),
        bairro: values.bairro.trim(),
        cidade: values.cidade.trim(),
        estado: values.estado.trim(),
        cep: cleanMask(values.cep).trim()

    })

    const companyHead: CompanyHead = new CompanyHead().fromJSON({
        nome: values.nomeResponsavel.trim(),
        telefone: cleanMask(values.telefoneResponsavel).trim(),
        cpf: cleanMask(values.cpfResponsavel).trim(),
        email: values.emailResponsavel.trim(),
        telefone2: values.telefoneResponsavel2 === '' || values.telefoneResponsavel2 === null ? null : cleanMask(values.telefoneResponsavel2).trim(),
    })

    const companyAdm: CompanyHead = new CompanyHead().fromJSON({
        nome: values.nomeAdministrador.trim(),
        telefone: cleanMask(values.telefoneAdministrador).trim(),
        cpf: cleanMask(values.cpfAdministrador).trim(),
        email: values.emailAdministrador.trim(),
        telefone2: values.telefoneAdministrador2 === '' || values.telefoneAdministrador2 === null ? null : cleanMask(values.telefoneAdministrador2).trim(),
    })

    const empresa: Company = new Company().fromJSON({
        razaoSocial: values.razaoSocial.trim(),
        nomeFantasia: values.nomeFantasia.trim(),
        usaClinicFrame: values.usaClinicFrame,
        clinicFrameUrl: values.clinicFrameUrl.trim(),
        clinicFrameApiUrl: values.clinicFrameApiUrl.trim(),
        cnpj: cleanMask(values.cnpj).trim(),
        unidadesAtendimento: [],
        telefones: [cleanMask(values.telefoneEmpresa).trim()],
        endereco: address,
        responsavelEmpresa: companyHead,
        administradorEmpresa: companyAdm,
    })

    return empresa;
}

export const registerCompany = (values: any, unids: any) => {
    const service: CompanyService = new CompanyService()
    return async () => {
        try {
            const empresa: Company = fillCompanyObject(values)
            empresa.unidadesAtendimento?.push(...unids);

            await service.registerCompany(empresa)
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const updateCompany = (values: any, companyId: string, unids: any) => {
    const service: CompanyService = new CompanyService()
    return async () => {
        try {
            const empresa: Company = new Company().fromJSON({ ...fillCompanyObject(values), id: companyId })
            empresa.unidadesAtendimento?.push(...unids);

            await service.editCompany(empresa, companyId)

        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const activateOrDeactivateCompany = (companyId: string, isActivate: boolean) => {
    const service: CompanyService = new CompanyService()
    return async (dispatch: any) => {
        try {
            if (isActivate) {
                await service.activateCompany(companyId)
            } else {
                await service.inactivateCompany(companyId)
            }
            fetchCompanyList();
        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const getCompaniesToUserRoleCombo = () => {
    const service: CompanyService = new CompanyService()
    return async (dispatch: any) => {
        try {
            const response: any = await service.getCompanies()
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            const companies: any[] = []

            baseResponse?.data?.forEach((data: any) => {
                companies.push({ label: data.nomeFantasia, value: data.nomeFantasia })
            })

            dispatch({
                type: FETCH_COMPANIES_COMBO,
                companiesCombo: companies
            })

        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}

export const listIdsUnids = (values: any) => {
    return async (dispatch: any) => {
        try {
            dispatch({
                type: SET_IDS_UNIDS,
                idsUnids: values
            })

        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}



